import { useEffect, useState } from "react";
import axios from "axios";

export default function ReportsPage() {
  const [trades, setTrades] = useState([]);

  useEffect(() => {
    axios
      .get("/api/reports/inception-ledger", { withCredentials: true })
      .then((res) => {
        const data = res?.data || {};
        
        // SAFE PARSE — never blank screen
        if (Array.isArray(data.trades)) {
          setTrades(data.trades);
        } else {
          console.warn("No trades array in response:", data);
          setTrades([]);
        }
      })
      .catch((err) => {
        console.error("Reports fetch error:", err);
        setTrades([]);
      });
  }, []);

  return (
    <div className="p-6 text-white font-mono">
      <h2 className="text-lg mb-4">Reports</h2>

      {trades.length === 0 ? (
        <div className="text-zinc-500">No trade history</div>
      ) : (
        <div className="space-y-2">
          {trades.map((t) => (
            <div key={t.id} className="border border-zinc-800 p-3 rounded">
              <div>ID: {t.trade_id || t.id}</div>
              <div>Status: {t.status}</div>
              <div>PNL: ${Number(t.pnl_usd ?? t.pnl ?? 0).toFixed(2)}</div>
              <div>Direction: {t.direction}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
